import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sizes-list" }
const _hoisted_2 = {
  key: 0,
  class: "sizes-list__title"
}
const _hoisted_3 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "item-sizes__icon" }
const _hoisted_6 = { class: "item-sizes__title" }
const _hoisted_7 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_8 = ["onClick", "onKeyup"]
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "item-sizes__icon" }
const _hoisted_11 = { class: "item-sizes__title" }
const _hoisted_12 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_13 = { class: "d-flex align-center" }
const _hoisted_14 = { class: "item-sizes__icon" }
const _hoisted_15 = { class: "item-sizes__title" }
const _hoisted_16 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_17 = ["onClick", "onKeyup"]
const _hoisted_18 = { class: "d-flex align-center" }
const _hoisted_19 = { class: "item-sizes__icon" }
const _hoisted_20 = { class: "item-sizes__title" }
const _hoisted_21 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_22 = { class: "sizes-list__items" }
const _hoisted_23 = { class: "d-flex align-center" }
const _hoisted_24 = { class: "item-sizes__icon" }
const _hoisted_25 = { class: "item-sizes__title" }
const _hoisted_26 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_27 = ["onClick", "onKeyup"]
const _hoisted_28 = { class: "d-flex align-center" }
const _hoisted_29 = { class: "item-sizes__icon" }
const _hoisted_30 = { class: "item-sizes__title" }
const _hoisted_31 = { class: "item-sizes__sizes d-flex align-center" }

import { computed, onMounted, ref, PropType } from 'vue';
import { storeToRefs } from 'pinia';
// import i18n from '@/plugins/i18n';
import { useAuthStore } from '@/store/auth';
import { useCommonStore } from '@/store/common';
// import { useEditorStore } from '@/store/editor';
import { ISize } from '@/types/ISize';
import { sizesEn } from '@/data/outpaintSizes/sizesEn';
import AiLocked from '@/components/UI/AiLocked/AiLocked.vue';
import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiBottomModal from '@/components/UI/AiBottomModal/AiBottomModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CanvasSizes',
  props: {
  height: {
    type: Number as PropType<number>,
    required: true,
  },
  width: {
    type: Number as PropType<number>,
    required: true,
  },
  isBlock: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  emits: ['update:width', 'update:height'],
  setup(__props, { emit: __emit }) {

const sizes = ref<ISize[]>(sizesEn);

const props = __props;

const emits = __emit;

const { isMobile } = storeToRefs(useCommonStore());
// const { generateImageData } = storeToRefs(useEditorStore());
const { profile } = storeToRefs(useAuthStore());

const selectedSize = ref<string>('');
const selectedItemKey = ref<number>(-2);
const customWidth = ref<number | null>(null);
const customHeight = ref<number | null>(null);
const showSizesModal = ref<boolean>(false);
const selectRef = ref<any | null>(null);

// const lang = computed(() => i18n.global.locale.value);
const permissions = computed(() => profile?.value?.permissions || []);

const canCustomResize = computed(() => !!permissions.value.find((perm: any) => perm === 'custom_resize'));

// const changeSizesArrHandler = (langVal: string): void => {
//   sizes.value = sizesEn;
// };

const selectSizeHandler = (item: ISize, key: number): void => {
  if (
    (item.width > 0 && item.height > 0) || (item.width === 0 && item.height === 0)
  ) {
    selectedSize.value = `${item.width} × ${item.height}`;
    selectedItemKey.value = key;
    emits('update:width', item.width);
    emits('update:height', item.height);
    showSizesModal.value = false;
  }
};

const toggleSizesModalHandler = (): void => {
  showSizesModal.value = !showSizesModal.value;
};

// const sizesWatcher = (): void => {
//   selectedSize.value = `${props.width} × ${props.height}`;
//   const elemIndex = sizes.value.findIndex((size: ISize) => size.width === props.width && size.height === props.height);
//   if (elemIndex !== -1) {
//     selectSizeHandler(sizes.value[elemIndex], elemIndex);
//     customWidth.value = null;
//     customHeight.value = null;
//   } else {
//     selectSizeHandler({ width: props.width, height: props.height }, -1);
//     customWidth.value = props.width;
//     customHeight.value = props.height;
//   }
// };

const selectFocusedHandler = (): void => {
  if (isMobile.value) {
    showSizesModal.value = true;
    selectRef.value.menu = false;
  }
};

onMounted(() => {
  // const { canvas } = generateImageData.value;
  const sizeIndex = sizes.value.findIndex(
    (size: ISize) => size.width === props.width && size.height === props.height,
  );
  if (sizeIndex !== -1) {
    selectSizeHandler(sizes.value[sizeIndex], sizeIndex);
  //   customWidth.value = null;
  //   customHeight.value = null;
  // // } else if (profile?.value?.permissions.indexOf('custom_resize') !== -1) {
  //   // selectSizeHandler({ width: props.width, height: props.height }, -1);
  //   // customWidth.value = props.width;
  //   // customHeight.value = props.height;
  } else {
    selectSizeHandler(sizes.value[0], 0);
  }
});

// watch(lang, (newVal) => {
//   changeSizesArrHandler(newVal);
//   selectSizeHandler(sizes.value[0], 0);
// });

// watch(
//   () => props.height,
//   () => {
//     sizesWatcher();
//   },
// );
// watch(
//   () => props.width,
//   () => {
//     sizesWatcher();
//   },
// );

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('editor.settings.size-title')), 1))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_v_spacer, { key: 1 }))
      : _createCommentVNode("", true),
    (__props.isBlock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["item-sizes d-flex align-center", { 'item-sizes--active': selectedItemKey.value === -1 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (
          canCustomResize.value ? selectSizeHandler({ width: customWidth.value || 100, height: customHeight.value || 100 }, -1) : null
        )),
            onKeyup: _cache[3] || (_cache[3] = ($event: any) => (selectSizeHandler({ width: customWidth.value || -1, height: customHeight.value || -1 }, -1)))
          }, [
            (!canCustomResize.value)
              ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_inline_svg, {
                  class: "stroke",
                  src: require('@/assets/icons/sizes/custom.svg')
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('editor.settings.custom')), 1)
            ]),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_text_field, {
                modelValue: customWidth.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customWidth).value = $event)),
                modelModifiers: { number: true, lazy: true },
                class: "item-sizes__input",
                "hide-details": "",
                height: "18"
              }, null, 8, ["modelValue"]),
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "item-sizes__divider" }, "×", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: customHeight.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customHeight).value = $event)),
                modelModifiers: { number: true, lazy: true },
                class: "item-sizes__input",
                "hide-details": ""
              }, null, 8, ["modelValue"])
            ])
          ], 34),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizes.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _mergeProps({
              key: item.width,
              class: [{ 'item-sizes--active': selectedItemKey.value === index }, "item-sizes d-flex align-center"],
              ref_for: true
            }, props, {
              onClick: ($event: any) => (selectSizeHandler(item, index)),
              onKeyup: ($event: any) => (selectSizeHandler(item, index))
            }), [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (item.width > item.height)
                    ? (_openBlock(), _createBlock(_component_inline_svg, {
                        key: 0,
                        class: "fill",
                        src: require('@/assets/icons/sizes/horisontal.svg')
                      }, null, 8, ["src"]))
                    : (item.width < item.height)
                      ? (_openBlock(), _createBlock(_component_inline_svg, {
                          key: 1,
                          class: "fill",
                          src: require('@/assets/icons/sizes/vertical.svg')
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_inline_svg, {
                          key: 2,
                          class: "fill",
                          src: require('@/assets/icons/sizes/square.svg')
                        }, null, 8, ["src"]))
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1)
              ]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(item.width) + " ", 1),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "item-sizes__divider" }, "×", -1)),
                _createTextVNode(" " + _toDisplayString(item.height), 1)
              ])
            ], 16, _hoisted_8))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_v_select, {
          key: 3,
          eager: "",
          modelValue: selectedSize.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedSize).value = $event)),
          items: sizes.value,
          "hide-details": "",
          class: "select-size",
          "menu-icon": "mdi-chevron-down",
          "menu-props": { class: 'sizes-menu' },
          "onUpdate:menu": selectFocusedHandler,
          ref_key: "selectRef",
          ref: selectRef
        }, {
          "prepend-item": _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["item-sizes d-flex align-center", { 'item-sizes--active': selectedItemKey.value === -1 }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (
            canCustomResize.value ? selectSizeHandler({ width: customWidth.value || -1, height: customHeight.value || -1 }, -1) : null
          )),
              onKeyup: _cache[8] || (_cache[8] = ($event: any) => (selectSizeHandler({ width: customWidth.value || -1, height: customHeight.value || -1 }, -1)))
            }, [
              (!canCustomResize.value)
                ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_inline_svg, {
                    class: "stroke",
                    src: require('@/assets/icons/sizes/custom.svg')
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('editor.settings.custom')), 1)
              ]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_v_text_field, {
                  modelValue: customWidth.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customWidth).value = $event)),
                  modelModifiers: { number: true, lazy: true },
                  class: "item-sizes__input",
                  "hide-details": "",
                  height: "18",
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["stop"]), ["tab"]))
                }, null, 8, ["modelValue"]),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "item-sizes__divider" }, "×", -1)),
                _createVNode(_component_v_text_field, {
                  modelValue: customHeight.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customHeight).value = $event)),
                  modelModifiers: { number: true, lazy: true },
                  class: "item-sizes__input",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ])
            ], 34)
          ]),
          item: _withCtx(({ index, item, props }) => [
            _createElementVNode("div", _mergeProps({
              class: [{ 'item-sizes--active': selectedItemKey.value === index }, "item-sizes d-flex align-center"]
            }, props, {
              onClick: ($event: any) => (selectSizeHandler(item.value, index)),
              onKeyup: ($event: any) => (selectSizeHandler(item.value, index))
            }), [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (item.value.width > item.value.height)
                    ? (_openBlock(), _createBlock(_component_inline_svg, {
                        key: 0,
                        class: "fill",
                        src: require('@/assets/icons/sizes/horisontal.svg')
                      }, null, 8, ["src"]))
                    : (item.value.width < item.value.height)
                      ? (_openBlock(), _createBlock(_component_inline_svg, {
                          key: 1,
                          class: "fill",
                          src: require('@/assets/icons/sizes/vertical.svg')
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_inline_svg, {
                          key: 2,
                          class: "fill",
                          src: require('@/assets/icons/sizes/square.svg')
                        }, null, 8, ["src"]))
                ]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(item.value.name), 1)
              ]),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(_toDisplayString(item.value.width) + " ", 1),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "item-sizes__divider" }, "×", -1)),
                _createTextVNode(" " + _toDisplayString(item.value.height), 1)
              ])
            ], 16, _hoisted_17)
          ]),
          _: 1
        }, 8, ["modelValue", "items"])),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(AiBottomModal, {
          key: 4,
          "show-modal": showSizesModal.value,
          "handle-toggle": toggleSizesModalHandler,
          title: _ctx.$t('editor.settings.size-title')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(AiClearButton, {
                class: _normalizeClass(["item-sizes d-flex align-center", { 'item-sizes--active': selectedItemKey.value === -1 }]),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (
            canCustomResize.value
              ? selectSizeHandler(
                  {
                    width: customWidth.value ? 1 : 100,
                    height: customHeight.value ? 1 : 100,
                  },
                  -1,
                )
              : null
          ))
              }, {
                default: _withCtx(() => [
                  (!canCustomResize.value)
                    ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_inline_svg, {
                        class: "stroke",
                        src: require('@/assets/icons/sizes/custom.svg')
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('editor.settings.custom')), 1)
                  ]),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_v_text_field, {
                      onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                      onBlur: _cache[11] || (_cache[11] = ($event: any) => (
                canCustomResize.value && customWidth.value && customHeight.value
                  ? selectSizeHandler({ width: customWidth.value || 100, height: customHeight.value || 100 }, -1)
                  : null
              )),
                      modelValue: customWidth.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customWidth).value = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "item-sizes__input",
                      "hide-details": "",
                      height: "18"
                    }, null, 8, ["modelValue"]),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "item-sizes__divider" }, "×", -1)),
                    _createVNode(_component_v_text_field, {
                      onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                      onBlur: _cache[14] || (_cache[14] = ($event: any) => (
                canCustomResize.value && customWidth.value && customHeight.value
                  ? selectSizeHandler({ width: customWidth.value || 100, height: customHeight.value || 100 }, -1)
                  : null
              )),
                      modelValue: customHeight.value,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((customHeight).value = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "item-sizes__input",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizes.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([{ 'item-sizes--active': selectedItemKey.value === index }, "item-sizes d-flex align-center"]),
                  onClick: ($event: any) => (selectSizeHandler(item, index)),
                  onKeyup: ($event: any) => (selectSizeHandler(item, index))
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      (item.width > item.height)
                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                            key: 0,
                            class: "fill",
                            src: require('@/assets/icons/sizes/horisontal.svg')
                          }, null, 8, ["src"]))
                        : (item.width < item.height)
                          ? (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 1,
                              class: "fill",
                              src: require('@/assets/icons/sizes/vertical.svg')
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 2,
                              class: "fill",
                              src: require('@/assets/icons/sizes/square.svg')
                            }, null, 8, ["src"]))
                    ]),
                    _createElementVNode("div", _hoisted_30, _toDisplayString(item.name), 1)
                  ]),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_31, [
                    _createTextVNode(_toDisplayString(item.width) + " ", 1),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "item-sizes__divider" }, "×", -1)),
                    _createTextVNode(" " + _toDisplayString(item.height), 1)
                  ])
                ], 42, _hoisted_27))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["show-modal", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})